<template>
  <div class="body">
    <div class="title">
      短信配置
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"><span class="dsadf">
            首页
          </span></el-breadcrumb-item>
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>短信配置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="btnsearch">
<!--      <div class="left">-->
<!--        <div class="rightfile">-->
<!--          <button class="btn">-->
<!--            <i class="el-icon-position"></i>-->
<!--            发送短信</button>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="基本配置" name="first">
        <el-form ref="form" :model="form" label-width="15%  " :label-position="labelPosition" >
          <el-form-item label="短信应用ID(appid)">
            <el-input v-model="form.accesskeyid"  placeholder="请输入短信应用ID/appid" style="min-width: 500px;width: 500px"></el-input>
          </el-form-item>
          <el-form-item label="秘钥/AppSecret">
            <el-input v-model="form.accesskeysecret"  placeholder="请输入秘钥/AppSecret" style="min-width: 500px;width: 500px"></el-input>
          </el-form-item>
          <el-form-item label="默认短信签名">
            <el-input v-model="form.signname"  placeholder="请输入默认短信签名" style="min-width: 500px;width: 500px"></el-input>
          </el-form-item>
          <el-form-item label="绑定手机号的短信模版代码">
            <el-input v-model="form.bing_templatecode"  placeholder="请输入绑定手机号的短信模版代码" style="min-width: 500px;width: 500px"></el-input>
          </el-form-item>
          <el-form-item label="用户登录的短信模版代码">
            <el-input v-model="form.login_templatecode"  placeholder="请输入用户登录的短信模版代码" style="min-width: 500px;width: 500px"></el-input>
          </el-form-item>
          <el-form-item label="忘记密码的短信模版代码">
            <el-input v-model="form.forgetpass_templatecode"  placeholder="请输入忘记密码的短信模版代码" style="min-width: 500px;width: 500px"></el-input>
          </el-form-item>
        </el-form>
        <button class="dsabbg" @click="baocun">
          保存设置
        </button>
      </el-tab-pane>
      <el-tab-pane label="微信支付配置" name="scound">
        <el-form ref="form" :model="form" label-width="15%  " :label-position="labelPosition" >
          <el-form-item label="微信小程序appid">
            <el-input v-model="form.wxxcx_appid"  placeholder="请输入微信小程序appid" style="min-width: 500px;width: 500px"></el-input>
          </el-form-item>
          <el-form-item label="微信小程序appsecret">
            <el-input v-model="form.wxxcx_appsecret"  placeholder="请输入微信小程序appsecret" style="min-width: 500px;width: 500px"></el-input>
          </el-form-item>
          <el-form-item label="微信支付商户号">
            <el-input v-model="form.merchant_no"  placeholder="请输入微信支付商户号" style="min-width: 500px;width: 500px"></el-input>
          </el-form-item>
          <el-form-item label="微信支付商户key">
            <el-input v-model="form.merchant_key"  placeholder="请输入微信支付商户key" style="min-width: 500px;width: 500px"></el-input>
          </el-form-item>
        </el-form>
        <button class="dsabbg" @click="bcaa">
          保存设置
        </button>
      </el-tab-pane>
    </el-tabs>
</div>
</template>

<script>
import { systemPayedit, systemSmsedit, systemView } from '@/api/xitongpeizhi'

export default {
  name: 'duanxinpeizhi',
  data () {
    return {
      activeName: 'first',
      labelPosition: 'left',
      form: {
        // 短信应用ID
        accesskeyid: '',
        // 短信应用密钥（appsecret）
        accesskeysecret: '',
        // 短信签名
        signname: '',
        // 绑定手机号的短信模版代码
        bing_templatecode: '',
        // 用户登录的短信模版代码
        login_templatecode: '',
        // 忘记密码的短信模版代码
        forgetpass_templatecode: '',
        // 微信小程序appid
        wxxcx_appid: '',
        // 微信小程序appsecret
        wxxcx_appsecret: '',
        // 微信支付商户号
        merchant_no: '',
        // 微信支付商户key
        merchant_key: ''
      },
      tableData: [
        {
          id: '1',
          name: '协会名称',
          leixing: 'ss',
          dizhi: 'ssaa',
          dianhua: 'ss',
          zhuangtai: 'sas',
          shijian: 'sss',
          shangjia: 'ssaa',
          zhiding: 'sasa'
        }
      ]
    }
  },
  created () {
    this.xiangqing()
  },
  methods: {
    bcaa () {
      const obj = {
        token: sessionStorage.getItem('token'),
        wxxcx_appid: this.form.wxxcx_appid,
        wxxcx_appsecret: this.form.wxxcx_appsecret,
        merchant_no: this.form.merchant_no,
        merchant_key: this.form.merchant_key
      }
      systemPayedit(obj).then(({ data: res }) => {
        console.log('res', res)
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          setTimeout(() => {
            window.sessionStorage.clear()
            this.$router.push('/login')
          }, 1000)
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          return false
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: '2000'
          })
          this.xiangqing()
        }
      })
    },
    baocun () {
      const obj = {
        token: sessionStorage.getItem('token'),
        accesskeyid: this.form.accesskeyid,
        accesskeysecret: this.form.accesskeysecret,
        signname: this.form.signname,
        bing_templatecode: this.form.bing_templatecode,
        login_templatecode: this.form.login_templatecode,
        forgetpass_templatecode: this.form.forgetpass_templatecode
      }
      systemSmsedit(obj).then(({ data: res }) => {
        console.log('res', res)
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          setTimeout(() => {
            window.sessionStorage.clear()
            this.$router.push('/login')
          }, 1000)
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          return false
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: '2000'
          })
          this.xiangqing()
        }
      })
    },
    xiangqing () {
      const obj = {
        token: sessionStorage.getItem('token')
      }
      systemView(obj).then(({ data: res }) => {
        console.log('res', res)
        this.form = res
      })
    }
  }
}
</script>

<style scoped lang="less">
.body {
  display: flex;
  flex-direction: column;
  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display:flex;
    flex-direction: row;
    align-items: center;
    .fansk{
      margin-top: 30px;
      margin-left: 32px;
    }
    .dsadf{
      color: #3D9AFF;
    }
  }
  .btnsearch{
    display:flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 50px;
    .left{
      margin-right: 150px;
      .btn{
        width: 124px;
        height: 43px;
        opacity: 1;
        background: linear-gradient(135deg,#1bb745, #17ab3f);
        border-radius: 5px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        letter-spacing: 0px;
        border:none;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .dsabbg{
    width: 107px;
    height: 36px;
    opacity: 1;
    background: linear-gradient(135deg,#3d9aff, #3380f2);
    border-radius: 2px;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
    letter-spacing: 0px;
    display:flex;
    justify-content: center;
    align-items: center;
    border: none;
  }
  .headertitle{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;
    .left{
      flex: 1;
      .btns{
        width: 123px;
        height: 43px;
        opacity: 1;
        background: linear-gradient(135deg,#3d9aff, #3380f2);
        border-radius: 5px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: left;
        color: #ffffff;
        letter-spacing: 0px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: none;
      }
    }
  }
  .rowtxt{
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .bianji{
    width: 78px;
    height: 37px;
    opacity: 1;
    border: 1px solid rgba(61,154,255,0.50);
    border-radius: 2px;
    font-size: 12px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #3d9aff;
    letter-spacing: 0px;
    background: white;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
  }
  .fasong{
    width: 78px;
    height: 37px;
    opacity: 1;
    border: 1px solid rgba(15,168,56,0.50);
    border-radius: 2px;
    font-size: 12px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #0fa838;
    letter-spacing: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    background: white;
  }
  .shanchu{
    width: 78px;
    height: 37px;
    opacity: 1;
    border: 1px solid rgba(229,72,72,0.50);
    border-radius: 2px;
    opacity: 1;
    font-size: 12px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #e54848;
    letter-spacing: 0px;
  }
}
</style>
